export default {"src":"/_next/static/image/public/images/icons1/3.d9bb0468935b76ff2d3124496aad6eab.svg","height":30,"width":22};